<style>
</style>

<script lang="ts">
  import type Projects from '../api/rest/directus-cms/projects/model/Projects'
  import Banner from '../components/Banner.svelte'
  import GrowingFamily from '../components/Growing_Family.svelte'
  import IdPublications from '../components/ID_Publications.svelte'
  import LibraryPlatform from '../components/Library_Platform.svelte'
  import Partners from '../components/Partners.svelte'
  import ProjectDataSection from '../components/Project_Data_Section.svelte'
  import ProjectDetails from '../components/Project_Details.svelte'
  import ProjectFormation from '../components/Project_Formation.svelte'
  import ProjectImpact from '../components/Project_Impact.svelte'
  import ProjectType1LastSection from '../components/Project_Type1_Last_Section.svelte'
  import ProjectInclusionSection from '../components/Project_Inclusion_Section.svelte'
  import SubscribeNewsletter from '../components/Subscribe_Newsletter.svelte'
  import type { Slugs } from '../config/slugs'
  import type ProjectFirstType from '../api/rest/directus-cms/projects/model/ProjectFirstType'

  export let p: Projects
  let slug: Slugs | undefined
  $: slug = p.project_link?.slug as unknown as Slugs | undefined
  const color_class = p.color_class ? p.color_class : ''
  let projectFirstType: ProjectFirstType | undefined
  let partnersArray: Projects['partners']
  let dataSection: ProjectFirstType['data_section']
  let formationSection: ProjectFirstType['formation_section']
  let resultsSection: ProjectFirstType['result_section']
  let publicationsSection: ProjectFirstType['publications_section']
  let inclusionSection: ProjectFirstType['financial_inclusion_section']
  let lastSection: ProjectFirstType['last_section_first_type']
  let isBannerLoaded = false
  $: {
    projectFirstType = p.project_first_type ?? p.project_first_type
    partnersArray = p.partners
    dataSection = projectFirstType?.data_section ?? projectFirstType?.data_section
    formationSection =
      projectFirstType?.formation_section ?? projectFirstType?.formation_section
    resultsSection = projectFirstType?.result_section ?? projectFirstType?.result_section
    publicationsSection =
      projectFirstType?.publications_section ?? projectFirstType?.publications_section
    inclusionSection =
      projectFirstType?.financial_inclusion_section ??
      projectFirstType?.financial_inclusion_section
    lastSection =
      projectFirstType?.last_section_first_type ??
      projectFirstType?.last_section_first_type
  }

  function setLoadedBanners() {
    isBannerLoaded = true
  }
</script>

<section>
  {#if slug}
    <Banner on:bannerLoaded={setLoadedBanners} {slug} />
  {/if}

  {#if isBannerLoaded}
    <ProjectDetails {color_class} {p} />
    {#if p.project_type == 1}
      {#if dataSection}
        <ProjectDataSection {partnersArray} />
      {/if}
      {#if formationSection}
        <ProjectFormation {color_class} {formationSection} />
      {/if}
      {#if resultsSection}
        <ProjectImpact {color_class} {resultsSection} />
      {/if}
      {#if lastSection}
        <ProjectType1LastSection {lastSection} />
      {/if}
      {#if inclusionSection}
        <ProjectInclusionSection {color_class} section={inclusionSection} />
      {/if}
      {#if publicationsSection}
        <IdPublications section={publicationsSection} />
      {/if}
    {/if}
    <LibraryPlatform />
    <GrowingFamily />
    <SubscribeNewsletter />
    <Partners />
  {/if}
</section>
